import { computed, inject, Service, OnDestroy, signal } from '@angular/core';
import { EDentalNotation } from 'app/core/enums/dental-notation.enum';
import { ITranslation } from 'app/core/models/dentistry/translation';
import { ILocationSetting } from 'app/core/models/location/location';
import { IOrder } from 'app/core/models/order/order';
import { DentistryService } from 'app/core/services/dentistry/dentistry.service';
import { OrderService } from 'app/core/services/order/order.service';
import { last, Observable, Subscription } from 'rxjs';

const TRANSLATION_INITIAL = { requested: false, data: [] };

@Service()
export class OrderDetailViewService implements OnDestroy {
    private readonly orderService = inject(OrderService);
    private readonly dentistryService = inject(DentistryService);

    public readonly locationSettings = signal<ILocationSetting | null>(null);
    public readonly order = signal<IOrder | null>(null);
    public readonly typeDentalNotation = computed(() => this.locationSettings()?.dentistryDentalNotation ?? EDentalNotation.UNIVERSAL_SYSTEM);
    public readonly translation = signal<{ requested: boolean; data: ITranslation[] }>(TRANSLATION_INITIAL);
    private readonly subscriptions = new Subscription();

    constructor() {}

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    public setOrder(data: IOrder): void {
        this.order.update((item) => ({ ...item, ...data }));
    }

    public clearOrder(): void {
        this.order.set(null);
    }

    public fetchDentistryTranslate(): Observable<void> {
        const { requested } = this.translation();

        return new Observable<void>((observer) => {
            if (requested) {
                observer.next();
                observer.complete();
                return;
            }

            this.dentistryService
                .getDentistryTranslation()
                .pipe(last())
                .subscribe({
                    next: ({ data }) => {
                        this.translation.set({ data, requested: true });
                        observer.next();
                        observer.complete();
                    },
                    error: (error) => {
                        observer.error(error);
                        observer.complete();
                    },
                });
        });
    }
}
